export default '/faq';
